import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { WorkflowDefineService } from 'tnx-admin-service/workflowcore/workflowdefine/services';
import { ColumnSchemaBase, ComponentContextService, CrudListComponent, DataListBase, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'workflowdefine',
    templateUrl: './workflowdefine.component.html',
    styleUrls: ['./workflowdefine.component.scss'],
    providers: [ComponentContextService],
})
export class WorkflowDefineComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _workflowDefineService: WorkflowDefineService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._workflowDefineService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'persistenceId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'createTime', dataType: 'date', name: 'Thời gian tạo', fullName: 'Thời gian tạo', description: 'Thời gian tạo' }),
            new ModelSchema({ field: 'content', name: 'Nội dung', fullName: 'Nội dung', description: 'Nội dung' }),
            new ModelSchema({ field: 'name', name: 'Tên quy trình', fullName: 'Tên quy trình', description: 'Tên quy trình' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: 'Mô tả' }),
            new ModelSchema({ field: 'status', dataType: 'int', name: 'Trạng thái', fullName: 'Trạng thái', description: 'Trạng thái' }),
            new ModelSchema({ field: 'bpmnContent', name: 'Nội dung bpmn', fullName: 'Nội dung bpmn', description: 'Nội dung bpmn' }),
            new ModelSchema({ field: 'code', name: 'Mã quy trình', fullName: 'Mã quy trình', description: 'Mã quy trình' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'version', name: 'Phiên bản', fullName: 'Phiên bản', description: 'Phiên bản' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'name' }),
            new ColumnSchemaBase({ field: 'version' }),
            new ColumnSchemaBase({ field: 'createTime', dataType: 'datetime' }),
        ];

        this.setting.objectName = 'quy trình';
        super.ngOnInit();
    }

    async afterGetData() {
        for (const item of this.model.dataSource) {
            item.id = item.persistenceId;
        }
    }

    add(evt) {
        this._router.navigate([`detail`], { relativeTo: this._activatedRoute });
    }

    edit(evt) {
        this._router.navigate([`detail/${evt.id}`], { relativeTo: this._activatedRoute });
    }

    view(evt) {
        this._router.navigate([`detail/${evt.id}`], { relativeTo: this._activatedRoute });
    }
}

